 const appColors = {

    primary: '#0044AA',
    primaryLight:'rgba(0, 68, 170, 0.5)',
    dataTableHeader: 'rgba(0, 68, 170, 0.3)',
    skyBlue: '#3897F0',
    appBg:'#ffffff',
    secondary: '#F6D240',
    bg: '#FAF9F6',
    buttonsPrimary: '#0065FD',
    success: '#37a653ff',
    vehListContainerBg: '#E9E8E7',
    yellow : 'rgba(255, 191, 0,0.7)',
    green: 'green',
    red : 'red',
    grey: '#D4D4D4',

    textInputPlaceHolder: '#AAACAE',
    textInputBorderColor: '#A9A9A9',
    greyText: '#A8A8A8',
    black: '#000000',
    white: '#FFFFFF',
    inputLabel: '#5F5F5F',
    textInputFontColor: '#1A1A1A',
    seperatorLine: 'grey',


};

export default appColors;